export const getMailMergeHintByKey = (mailMergeData, hintKey) => mailMergeData?.hint?.find(({ name }) => name === hintKey) || {};

export const getFirstTransparencyCode = mailMergeData => {
  const useFirstRowAsPlaceholder = getMailMergeHintByKey(mailMergeData, 'useFirstRowAsPlaceholder');
  const mmdSize = mailMergeData?.row?.length;
  const firstCodePosition = mmdSize > 1 && useFirstRowAsPlaceholder ? 1 : 0;

  const { Column: [firstCodeColumn = {}] = [] } = mailMergeData?.row[firstCodePosition] || {};
  const { value: firstTransparencyCode = '' } = firstCodeColumn;

  return firstTransparencyCode;
};

export const getLastTransparencyCode = mailMergeData => {
  const mmdSize = mailMergeData?.row?.length;
  const lastCodePosition = mmdSize - 1;

  const { Column: [lastCodeColumn = {}] = [] } = mailMergeData?.row[lastCodePosition] || {};
  const { value: lastTransparencyCode = '' } = lastCodeColumn;

  return lastTransparencyCode;
};

const getBarcodeDataProp = ({ properties }) => properties.find(({ name }) => name === 'data');

const getFirstCodeData = mailMerge => ({
  mailMergeField: mailMerge['header-row'].Column[0].value || '',
  value: getFirstTransparencyCode(mailMerge),
});

export const mergeDataToBarcode = (barcodeField, mailMerge) => {
  const barcodeData = getBarcodeDataProp(barcodeField);
  const { mailMergeField, value } = getFirstCodeData(mailMerge);
  barcodeData.mailMergeField = mailMergeField;
  barcodeData.value = value;
};
